"use client";

import { useState } from 'react';

export default function PharmaDashboardsSection() {
  const [activeTab, setActiveTab] = useState(0);

  const dashboards = [
    {
      title: 'Executive Dashboard',
      subtitle: 'Executive Pharma Intelligence',
      svg: (
        <svg viewBox="0 0 700 420" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          {/* Background */}
          <rect width="700" height="420" fill="#F8F6F3" rx="12" />
          {/* Header */}
          <rect width="700" height="44" fill="#1B2845" rx="12" />
          <rect x="0" y="32" width="700" height="12" fill="#1B2845" />
          <text x="20" y="28" fill="white" fontSize="13" fontWeight="bold" fontFamily="sans-serif">Pharmaceutical Executive Dashboard</text>
          <text x="580" y="28" fill="#C5A572" fontSize="11" fontFamily="sans-serif">Live ●</text>

          {/* KPI Cards */}
          {[
            { x: 16,  label: 'Total Revenue',       value: '₹384Cr', sub: '+11.4% YoY',           color: '#1B2845' },
            { x: 186, label: 'Compliance Score',     value: '96.2%',  sub: 'Target: 95%+',          color: '#16a34a' },
            { x: 356, label: 'Expiry Risk Value',    value: '₹2.8Cr', sub: '↓ 38% vs last quarter', color: '#C5A572' },
            { x: 526, label: 'Active Distributors',  value: '214',    sub: '91.4% on-time delivery', color: '#1B2845' },
          ].map((kpi, i) => (
            <g key={i}>
              <rect x={kpi.x} y="56" width="158" height="68" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
              <text x={kpi.x + 12} y="76"  fill="#6b7280" fontSize="9"  fontFamily="sans-serif">{kpi.label}</text>
              <text x={kpi.x + 12} y="96"  fill={kpi.color} fontSize="18" fontWeight="bold" fontFamily="sans-serif">{kpi.value}</text>
              <text x={kpi.x + 12} y="114" fill="#9ca3af" fontSize="9"  fontFamily="sans-serif">{kpi.sub}</text>
            </g>
          ))}

          {/* Revenue by Therapeutic Area — horizontal bars */}
          <rect x="16" y="136" width="330" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="156" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Revenue by Therapeutic Area</text>
          {[
            { label: 'Oncology',    val: 190, color: '#1B2845', display: '₹142Cr' },
            { label: 'Diabetes',    val: 148, color: '#C5A572', display: '₹98Cr'  },
            { label: 'Cardiology',  val: 114, color: '#2E5A8F', display: '₹76Cr'  },
            { label: 'Respiratory', val: 82,  color: '#7C9BC7', display: '₹54Cr'  },
            { label: 'Neurology',   val: 52,  color: '#10b981', display: '₹34Cr'  },
          ].map((bar, i) => (
            <g key={i}>
              <text x="28" y={175 + i * 24} fill="#6b7280" fontSize="9" fontFamily="sans-serif">{bar.label}</text>
              <rect x="108" y={163 + i * 24} width={bar.val} height="14" fill={bar.color} rx="2" opacity="0.85" />
              <text x={114 + bar.val} y={175 + i * 24} fill="#374151" fontSize="9" fontFamily="sans-serif">{bar.display}</text>
            </g>
          ))}

          {/* Territory Profitability Heatmap */}
          <rect x="358" y="136" width="326" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="370" y="156" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Territory Profitability</text>
          {[
            { region: 'North India',      margin: '22.4%', color: '#16a34a', w: 210 },
            { region: 'West India',       margin: '18.6%', color: '#65a30d', w: 175 },
            { region: 'South India',      margin: '15.2%', color: '#ca8a04', w: 143 },
            { region: 'East India',       margin: '11.8%', color: '#ea580c', w: 111 },
            { region: 'Export Markets',   margin: '8.3%',  color: '#dc2626', w: 78  },
          ].map((p, i) => (
            <g key={i}>
              <text x="370" y={175 + i * 24} fill="#6b7280" fontSize="9" fontFamily="sans-serif">{p.region}</text>
              <rect x="468" y={163 + i * 24} width={p.w} height="14" fill={p.color} rx="2" opacity="0.75" />
              <text x="474" y={175 + i * 24} fill="white" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{p.margin}</text>
            </g>
          ))}

          {/* Monthly Revenue Trend */}
          <rect x="16" y="328" width="668" height="80" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="346" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Monthly Revenue Trend (₹ Cr)</text>
          <polyline points="50,398 130,390 210,385 290,375 370,368 450,358 530,348 620,336 680,324"
            fill="none" stroke="#1B2845" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
          <polyline points="50,398 130,390 210,385 290,375 370,368 450,358 530,348 620,336 680,324 680,405 50,405 Z"
            fill="#1B2845" opacity="0.06" />
          {[50,130,210,290,370,450,530,620,680].map((x, i) => (
            <circle key={i} cx={x} cy={[398,390,385,375,368,358,348,336,324][i]} r="3" fill="#C5A572" />
          ))}
          {['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep'].map((m, i) => (
            <text key={i} x={[50,130,210,290,370,450,530,620,680][i] - 8} y="410" fill="#9ca3af" fontSize="8" fontFamily="sans-serif">{m}</text>
          ))}
        </svg>
      ),
    },
    {
      title: 'SUPPLY CHAIN DASHBOARD',
      subtitle: 'Inventory, Batch & Expiry Intelligence',
      svg: (
        <svg viewBox="0 0 700 420" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <rect width="700" height="420" fill="#F8F6F3" rx="12" />
          <rect width="700" height="44" fill="#1B2845" rx="12" />
          <rect x="0" y="32" width="700" height="12" fill="#1B2845" />
          <text x="20" y="28" fill="white" fontSize="13" fontWeight="bold" fontFamily="sans-serif">Supply Chain & Inventory Dashboard</text>
          <text x="580" y="28" fill="#C5A572" fontSize="11" fontFamily="sans-serif">Live ●</text>

          {/* KPI Cards */}
          {[
            { x: 16,  label: 'Inventory Accuracy',  value: '98.4%', color: '#16a34a' },
            { x: 186, label: 'Items Near Expiry',   value: '12',    color: '#dc2626' },
            { x: 356, label: 'Batch Traceability',  value: '100%',  color: '#1B2845' },
            { x: 526, label: 'Warehouse Utilization', value: '74%', color: '#C5A572' },
          ].map((kpi, i) => (
            <g key={i}>
              <rect x={kpi.x} y="56" width="158" height="60" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
              <text x={kpi.x + 12} y="74" fill="#6b7280" fontSize="9"  fontFamily="sans-serif">{kpi.label}</text>
              <text x={kpi.x + 12} y="96" fill={kpi.color} fontSize="20" fontWeight="bold" fontFamily="sans-serif">{kpi.value}</text>
            </g>
          ))}

          {/* Product Stock Levels */}
          <rect x="16" y="128" width="330" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="148" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Stock Levels by Product</text>
          {[
            { product: 'Amoxicillin 500mg',   pct: 87, color: '#16a34a' },
            { product: 'Atorvastatin 40mg',   pct: 72, color: '#65a30d' },
            { product: 'Metformin 1000mg',    pct: 58, color: '#ca8a04' },
            { product: 'Amlodipine 10mg',     pct: 34, color: '#ea580c' },
            { product: 'Insulin Glargine',    pct: 18, color: '#dc2626' },
          ].map((m, i) => (
            <g key={i}>
              <text x="28" y={168 + i * 26} fill="#374151" fontSize="9" fontFamily="sans-serif">{m.product}</text>
              <rect x="158" y={156 + i * 26} width="150" height="14" fill="#f3f4f6" rx="3" />
              <rect x="158" y={156 + i * 26} width={m.pct * 1.5} height="14" fill={m.color} rx="3" opacity="0.85" />
              <text x="316" y={168 + i * 26} fill="#374151" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{m.pct}%</text>
            </g>
          ))}

          {/* Expiry Alerts */}
          <rect x="358" y="128" width="326" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="370" y="148" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Expiry & Recall Alerts</text>
          {[
            { batch: 'Batch PH-2847', product: 'Insulin Glargine 100U', days: '12 days', severity: 'HIGH', color: '#dc2626', bg: '#fef2f2' },
            { batch: 'Batch MF-1923', product: 'Metformin 1000mg',     days: '28 days', severity: 'MED',  color: '#ea580c', bg: '#fff7ed' },
            { batch: 'Batch AT-4201', product: 'Atorvastatin 40mg',    days: '45 days', severity: 'LOW',  color: '#ca8a04', bg: '#fefce8' },
          ].map((alert, i) => (
            <g key={i}>
              <rect x="370" y={158 + i * 50} width="302" height="40" fill={alert.bg} rx="6" />
              <text x="382" y={174 + i * 50} fill="#374151" fontSize="10" fontWeight="bold" fontFamily="sans-serif">{alert.batch}</text>
              <text x="382" y={188 + i * 50} fill="#6b7280" fontSize="9" fontFamily="sans-serif">{alert.product} · {alert.days}</text>
              <rect x="612" y={162 + i * 50} width="48" height="18" fill={alert.color} rx="4" />
              <text x="636" y={175 + i * 50} fill="white" fontSize="9" fontWeight="bold" fontFamily="sans-serif" textAnchor="middle">{alert.severity}</text>
            </g>
          ))}

          {/* Distributor Fulfillment Performance */}
          <rect x="16" y="320" width="668" height="88" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="338" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Distributor Fulfillment Performance</text>
          <rect x="16" y="344" width="668" height="1" fill="#e5e7eb" />
          {[
            { name: 'MedPlus Pharma',   lead: '2 days', ontime: '97%', status: '#16a34a' },
            { name: 'Apollo Wholesale',  lead: '3 days', ontime: '91%', status: '#65a30d' },
            { name: 'Fortis Dist.',      lead: '5 days', ontime: '79%', status: '#ca8a04' },
            { name: 'Generic Traders',   lead: '8 days', ontime: '64%', status: '#dc2626' },
          ].map((s, i) => (
            <g key={i}>
              <text x={28 + i * 168} y="362" fill="#374151" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{s.name}</text>
              <text x={28 + i * 168} y="376" fill="#6b7280" fontSize="9" fontFamily="sans-serif">Lead: {s.lead}</text>
              <rect x={28 + i * 168} y="382" width="50" height="14" fill={s.status} rx="3" opacity="0.15" />
              <text x={28 + i * 168 + 4} y="393" fill={s.status} fontSize="9" fontWeight="bold" fontFamily="sans-serif">{s.ontime} OT</text>
            </g>
          ))}
        </svg>
      ),
    },
    {
      title: 'REGULATORY & QUALITY DASHBOARD',
      subtitle: 'Compliance, Audit & CAPA Intelligence',
      svg: (
        <svg viewBox="0 0 700 420" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <rect width="700" height="420" fill="#F8F6F3" rx="12" />
          <rect width="700" height="44" fill="#1B2845" rx="12" />
          <rect x="0" y="32" width="700" height="12" fill="#1B2845" />
          <text x="20" y="28" fill="white" fontSize="13" fontWeight="bold" fontFamily="sans-serif">Regulatory & Quality Assurance Dashboard</text>
          <text x="580" y="28" fill="#C5A572" fontSize="11" fontFamily="sans-serif">Live ●</text>

          {/* KPI Cards */}
          {[
            { x: 16,  label: 'Audit Readiness',     value: '94.8%', color: '#16a34a' },
            { x: 186, label: 'Open Deviations',      value: '3',     color: '#dc2626' },
            { x: 356, label: 'CAPA Completion',      value: '87.5%', color: '#C5A572' },
            { x: 526, label: 'Documentation Score',  value: '98.2%', color: '#1B2845' },
          ].map((kpi, i) => (
            <g key={i}>
              <rect x={kpi.x} y="56" width="158" height="60" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
              <text x={kpi.x + 12} y="74" fill="#6b7280" fontSize="9"  fontFamily="sans-serif">{kpi.label}</text>
              <text x={kpi.x + 12} y="96" fill={kpi.color} fontSize="20" fontWeight="bold" fontFamily="sans-serif">{kpi.value}</text>
            </g>
          ))}

          {/* Compliance Score by Framework */}
          <rect x="16" y="128" width="330" height="190" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="148" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Compliance Score by Framework</text>
          {[
            { framework: 'FDA 21 CFR Part 11', score: 97, color: '#16a34a' },
            { framework: 'EU GMP Annex 11',    score: 94, color: '#65a30d' },
            { framework: 'WHO GMP',             score: 96, color: '#16a34a' },
            { framework: 'ICH Q10',             score: 91, color: '#ca8a04' },
            { framework: 'Schedule M (India)',  score: 89, color: '#ea580c' },
            { framework: 'ISO 15189',           score: 93, color: '#65a30d' },
          ].map((f, i) => (
            <g key={i}>
              <text x="28" y={168 + i * 24} fill="#374151" fontSize="9" fontFamily="sans-serif">{f.framework}</text>
              <rect x="162" y={156 + i * 24} width="148" height="14" fill="#f3f4f6" rx="3" />
              <rect x="162" y={156 + i * 24} width={f.score * 1.48} height="14" fill={f.color} rx="3" opacity="0.8" />
              <text x="318" y={168 + i * 24} fill="#374151" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{f.score}%</text>
            </g>
          ))}

          {/* CAPA Tracker */}
          <rect x="358" y="128" width="326" height="190" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="370" y="148" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">CAPA Tracker</text>
          {[
            { id: 'DEV-2024-041', desc: 'Dissolution test OOS result',    due: '30 days', status: 'In Progress', color: '#ea580c', bg: '#fff7ed' },
            { id: 'DEV-2024-038', desc: 'Sterility failure — Line C',     due: '15 days', status: 'Under Review', color: '#dc2626', bg: '#fef2f2' },
            { id: 'DEV-2024-035', desc: 'Label reconciliation variance',  due: 'Closed',  status: 'Closed',      color: '#16a34a', bg: '#f0fdf4' },
            { id: 'DEV-2024-031', desc: 'Microbial exceedance — WFI',     due: '8 days',  status: 'Escalated',   color: '#dc2626', bg: '#fef2f2' },
          ].map((capa, i) => (
            <g key={i}>
              <rect x="370" y={155 + i * 40} width="302" height="32" fill={capa.bg} rx="5" />
              <text x="382" y={168 + i * 40} fill="#374151" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{capa.id}</text>
              <text x="382" y={180 + i * 40} fill="#6b7280" fontSize="8" fontFamily="sans-serif">{capa.desc}</text>
              <text x="604" y={168 + i * 40} fill={capa.color} fontSize="8" fontWeight="bold" fontFamily="sans-serif" textAnchor="end">{capa.status}</text>
              <text x="604" y={180 + i * 40} fill="#9ca3af" fontSize="8" fontFamily="sans-serif" textAnchor="end">Due: {capa.due}</text>
            </g>
          ))}

          {/* Batch Release Summary */}
          <rect x="16" y="330" width="668" height="78" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="348" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Batch Release Summary — Current Quarter</text>
          {[
            { label: 'Batches Released', value: '1,284', color: '#16a34a', x: 28   },
            { label: 'Batches On Hold',  value: '7',     color: '#ea580c', x: 220  },
            { label: 'Recall Risk',      value: '0',     color: '#1B2845', x: 412  },
            { label: 'Avg Release Time', value: '4.2d',  color: '#C5A572', x: 542  },
          ].map((m, i) => (
            <g key={i}>
              <text x={m.x} y="368" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{m.label}</text>
              <text x={m.x} y="390" fill={m.color} fontSize="18" fontWeight="bold" fontFamily="sans-serif">{m.value}</text>
            </g>
          ))}
        </svg>
      ),
    },
  ];

  return (
    <section className="py-24 bg-cream px-4 sm:px-6 lg:px-8 xl:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-serif text-navy text-2xl sm:text-3xl md:text-4xl xl:text-[3rem] leading-[1.2] font-bold mb-4">
            Role-Specific Intelligence for <span className="italic">Every Stakeholder</span>
          </h2>
          <p className="text-charcoal/70 text-lg max-w-2xl mx-auto">
            Purpose-built dashboards for every decision-maker in your pharmaceutical organization.
          </p>
        </div>

        {/* Tab Navigation */}
        <div className="flex flex-wrap gap-3 justify-center mb-10">
          {dashboards.map((d, i) => (
            <button
              key={i}
              onClick={() => setActiveTab(i)}
              className={`px-5 py-2.5 rounded-lg text-sm font-semibold transition-all duration-200 ${
                activeTab === i
                  ? 'bg-navy text-white shadow-md'
                  : 'bg-white text-navy border border-gray-200 hover:border-gold/40'
              }`}
            >
              {d.title}
            </button>
          ))}
        </div>

        {/* Dashboard Display */}
        <div className="bg-white rounded-2xl p-6 md:p-8 border border-gray-200 shadow-sm">
          <div className="mb-4">
            <h3 className="font-serif text-navy text-xl font-bold">{dashboards[activeTab].title}</h3>
            <p className="text-charcoal/60 text-sm mt-1">{dashboards[activeTab].subtitle}</p>
          </div>
          <div className="w-full aspect-[700/420] rounded-xl overflow-hidden border border-gray-100">
            {dashboards[activeTab].svg}
          </div>
          <div className="flex gap-4 mt-6">
            <button className="bg-navy hover:bg-navy/90 text-white text-sm font-semibold px-6 py-2.5 rounded-lg transition-all duration-200">
              View Demo
            </button>
            <button className="border border-navy text-navy hover:bg-navy/5 text-sm font-semibold px-6 py-2.5 rounded-lg transition-all duration-200">
              Request Customization
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
